import { QueryClientProvider, type QueryClient } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import { ApiClientProvider, createApiClient, type ApiClient } from '@/api'
import { AppRoutes } from '@/app/AppRoutes'
import { queryClient as defaultQueryClient } from '@/lib/queryClient'

const defaultApiClient = createApiClient()

export function App({
  client = defaultApiClient,
  queryClient = defaultQueryClient,
}: {
  client?: ApiClient
  queryClient?: QueryClient
}) {
  return (
    <ApiClientProvider client={client}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </ApiClientProvider>
  )
}
